var exports = {
  "kL": "x936d19a0--416f13--container",
  "Ql": "x936d19a0--416f13--container_high_rate",
  "Kg": "x936d19a0--416f13--container_low_rate",
  "YB": "x936d19a0--416f13--columns",
  "Jh": "x936d19a0--416f13--left_column",
  "_S": "x936d19a0--416f13--right_column",
  "_k": "x936d19a0--416f13--general_info",
  "TS": "x936d19a0--416f13--rate",
};

module.exports = exports;
